import { useCallback } from 'react';
import { OFFER_STEPS } from '../constants/steps';
import { useCreateOfferContext } from '../context/CreateOfferContext';

export function useUpdateStep() {
  const { updateContext } = useCreateOfferContext();

  const updateStep = useCallback(
    (step: number) => {
      // Keep the query string: the page reads sourceId/buyerId/listingId/
      // buyerType from it, and a bare path would drop them on refresh.
      const { search } = window.location;
      if (step === OFFER_STEPS.address) {
        window.history.replaceState(null, '', `/txm/offers/new${search}`);
      } else if (step === OFFER_STEPS.buyer) {
        window.history.pushState(null, '', `/txm/offers/new/buyers${search}`);
      }

      updateContext({ step });
    },
    [updateContext],
  );

  return updateStep;
}
